<div class="dialog-container addmasterproduct">
    <div class="dialog-title-block">
        <h2>Add Store</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </div>
    <form #f="ngForm" name="form" novalidate> 
        <div class="dialog-content-block">
            <div class="form-row">
                <div class="form-col"> 
                    <div class="form-group"> 
                        <label class="form-label">Region <span class="required">*</span></label>
                        <div class="cabinet-dropdown stores"> 
                            <div class="w-100">
                                <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isRegionDropDown.set(!isRegionDropDown())">
                                    <span class="dropdown-text">{{ selectedRegion?.value || 'Select Region' }}</span>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="isRegionDropDown()">
                                        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <ul class="dropdown-menu dropdown-content" [class.show]="isRegionDropDown()">
                                    <li *ngFor="let region of regions" class="dropdown-item" (click)="onRegionTypeChange(region)">{{ region.value }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-col"> 
                    <div class="form-group"> 
                        <div class="cabinet-dropdown stores"> 
                            <label class="form-label">Country <span class="required">*</span></label>
                            <div class="w-100">
                                <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isCountryDropDown.set(!isCountryDropDown())">
                                    <span class="dropdown-text">{{ selectedCountry?.value || 'Select Country' }}</span>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="isCountryDropDown()">
                                        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <ul class="dropdown-menu dropdown-content" [class.show]="isCountryDropDown()">
                                    <li *ngFor="let country of country" class="dropdown-item" (click)="onCountryTypeChange(country)">{{ country.value }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-col"> 
                    <div class="form-group"> 
                        <div class="cabinet-dropdown stores"> 
                            <label class="form-label">City <span class="required">*</span></label>
                            <div class="w-100">
                                <span class="drop-down-btn header d-flex align-items-center justify-content-between" (click)="isCitiesDropDown.set(!isCitiesDropDown())">
                                    <span class="dropdown-text">{{ selectedCities?.value || 'Select City' }}</span>
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="isCitiesDropDown()">
                                        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                <ul class="dropdown-menu dropdown-content" [class.show]="isCitiesDropDown()">
                                    <li *ngFor="let cities of cities" class="dropdown-item" (click)="onCitiesTypeChange(cities)">{{ cities.value }}</li>
                                </ul>
                            </div>
                        </div> 
                    </div>
                </div>
                <div class="form-col"> 
                    <div class="form-group">
                        <label class="form-label">Store Name <span class="required">*</span></label>
                        <input type="text" name="name" [(ngModel)]="nameTxt" placeholder="Enter store name" class="form-input">
                        <div class="form-error-msg"></div>
                    </div> 
                </div>
            </div>
            <div class="form-row">
                <div class="form-col">
                    <div class="form-group">
                        <label class="form-label">Latitude</label>
                        <input type="text" name="latitude" [(ngModel)]="latitudeTxt" placeholder="Enter latitude" class="form-input">
                        <div class="form-error-msg"></div>
                    </div> 
                </div> 
                <div class="form-col">
                    <div class="form-group">
                        <label class="form-label">Longitude</label>
                        <input type="text" name="longitude" [(ngModel)]="longitudeTxt" placeholder="Enter longitude" class="form-input">
                        <div class="form-error-msg"></div>
                    </div> 
                </div>
            </div>
            <div class="form-row">
                <div class="form-col-full">
                    <div class="form-group">
                        <label class="form-label">Consumption Email Recipients <span class="required">*</span></label>
                        <div class="email-chip-input-wrapper" [class.has-chips]="consumptionEmails.length > 0">
                            <div class="email-chips-container">
                                <div class="email-chip" *ngFor="let email of consumptionEmails">
                                    <span class="email-chip-text">{{ email }}</span>
                                    <button type="button" class="email-chip-remove" (click)="removeConsumptionEmail(email)" aria-label="Remove email">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>
                                </div>
                                <input 
                                    type="text" 
                                    [(ngModel)]="consumptionEmailInput" 
                                    name="consumptionEmailInput"
                                    placeholder="{{ consumptionEmails.length === 0 ? 'Enter email addresses' : '' }}"
                                    class="email-chip-input"
                                    (keydown)="onConsumptionEmailKeyDown($event)"
                                    (blur)="onConsumptionEmailBlur()"
                                    autocomplete="off">
                            </div>
                        </div>
                        <div class="form-error-msg" *ngIf="invalidEmailError">
                            <span>{{ invalidEmailError }}</span>
                        </div>
                        <div class="form-error-msg" *ngIf="consumptionEmails.length === 0 && f.submitted">
                            <span>At least one email address is required</span>
                        </div>
                        <div class="form-hint">Press Enter or comma to add email addresses</div>
                    </div> 
                </div> 
            </div>
            <div class="form-row">
                <div class="form-col-full">
                    <div class="form-group">
                        <label class="form-label">Low Stock Alert Email Recipients <span class="required">*</span></label>
                        <div class="email-chip-input-wrapper" [class.has-chips]="lowStockAlertEmails.length > 0">
                            <div class="email-chips-container">
                                <div class="email-chip" *ngFor="let email of lowStockAlertEmails">
                                    <span class="email-chip-text">{{ email }}</span>
                                    <button type="button" class="email-chip-remove" (click)="removeLowStockAlertEmail(email)" aria-label="Remove email">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>
                                </div>
                                <input 
                                    type="text" 
                                    [(ngModel)]="lowStockAlertEmailInput" 
                                    name="lowStockAlertEmailInput"
                                    placeholder="{{ lowStockAlertEmails.length === 0 ? 'Enter email addresses' : '' }}"
                                    class="email-chip-input"
                                    (keydown)="onLowStockAlertEmailKeyDown($event)"
                                    (blur)="onLowStockAlertEmailBlur()"
                                    autocomplete="off">
                            </div>
                        </div>
                        <div class="form-error-msg" *ngIf="invalidLowStockEmailError">
                            <span>{{ invalidLowStockEmailError }}</span>
                        </div>
                        <div class="form-error-msg" *ngIf="lowStockAlertEmails.length === 0 && f.submitted">
                            <span>At least one email address is required</span>
                        </div>
                        <div class="form-hint">Press Enter or comma to add email addresses</div>
                    </div> 
                </div> 
            </div>
        </div>
        <div class="dialog-footer">
            <button type="button" class="btn-cancel" (click)="onClose()">Cancel</button>
            <button class="btn-primary addproduct" type="submit" (click)="onAdd()">Add Store</button>
        </div>
    </form> 
</div>
